// we can either import Klaro without styles...
import * as Klaro from "klaro/dist/klaro-no-css";
// and the manually load the styles (e.g. to bundle them manually)
import "klaro/dist/klaro.css";

import './klaro-theme.css';

// 🧠 Fallback-Config, falls APP_CONFIG zu spät kommt
window.APP_CONFIG = window.APP_CONFIG || {
    hCaptchaEnabled: false,
    reCaptchaEnabled: false,
    friendlyCaptchaEnabled: false
}

window.klaro = Klaro;

import klaroConfig from './klaro-config.js'
window.klaroConfig = klaroConfig;

Klaro.setup(klaroConfig);

import { default as JustValidate } from "just-validate";
console.log("JustValidate is loaded:", JustValidate); // This prevents tree shaking
// Make JustValidate available globally
window.JustValidate = JustValidate;

import { Grid, html } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
window.Grid = Grid;
window.gridjs = Grid;
window.html = html;

import { deDE } from "gridjs/l10n";
window.deDE = deDE;

require("@popperjs/core");

import * as bootstrap from "bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
window.bootstrap = bootstrap;

// Import Flatpickr
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { German } from "flatpickr/dist/l10n/de.js";

require('@fortawesome/fontawesome-free/css/all.css');
//require('@fortawesome/fontawesome-free/js/all');

import Cropper from 'cropperjs';
window.Cropper = Cropper;


require('./layout.css');

import Swal from 'sweetalert2/dist/sweetalert2.js'; 
window.Swal = Swal; 
import 'sweetalert2/dist/sweetalert2.css';  //

import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'

import SignaturePad from 'signature_pad';
window.SignaturePad = SignaturePad;

require('./customValidation.js');